import { makeStyles } from "@material-ui/core/styles";

export const useSearchProductsTableRowStyles = makeStyles(() => ({
  added: {
    cursor: "default",
  },
}));
